import { render } from "./basic.vue?vue&type=template&id=114f1625&scoped=true"
import script from "./basic.vue?vue&type=script&lang=js"
export * from "./basic.vue?vue&type=script&lang=js"

import "./basic.vue?vue&type=style&index=0&id=114f1625&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-114f1625"]])

export default __exports__